import { useQuery } from '@tanstack/react-query';
import studioApiClient from '../api/studio';

export const ONBOARDING_IMAGES_QUERY_KEY = 'studio-onboarding-images';

const useOnboardingImages = () => {
  return useQuery({
    queryKey: [ONBOARDING_IMAGES_QUERY_KEY],
    queryFn: () => studioApiClient.getOnboardingImages(),
  });
};

export default useOnboardingImages;
